export default __webpack_public_path__ + "static/media/wonderschool-onboarding-student.09b591a8.csv";